import React, { useState, useEffect, useCallback } from "react";
import styled, { css } from "styled-components";
import { MobileView } from "react-device-detect";
import { Link, useLocation } from "react-router-dom";
import { bindActionCreators } from "redux";
import { useDispatch } from "react-redux";
import { useSelector } from "react-redux";
import { toast } from "react-toastify";
import axios from "axios";

import Button from "../components/Button";
import { SmallAvatar } from "../components/Avatar";
import Modal from "../components/Modal";
import AuthModal from "../components/modals/Authentication";
import StartStreamV2 from "../components/modals/StartStreamV2";
import { handleBigNumbers, To2Digits } from "../utils";
import { actionCreators } from "../state/index";
import { ENV_CONFIG } from "../config/environment-unified";
import useTranslation from "../hooks/useTranslation";

// Import Icons
import BrandLogo from "../components/BrandLogo";
import { ReactComponent as HomeIcon } from "../img/icons/home.svg";
import { ReactComponent as LogoutIcon } from "../img/icons/logout.svg";
import { ReactComponent as VideoIcon } from "../img/icons/video.svg";
// Using GameIcon as EventIcon for now - you can replace with a dedicated event icon later
import { ReactComponent as EventIcon } from "../img/icons/game.svg";
import { isArray } from "lodash";
// import { ReactComponent as HelpIcon } from "../img/icons/help.svg";
// import { ReactComponent as CreateIcon } from "../img/icons/create.svg";
// import { ReactComponent as PlayIcon } from "../img/icons/play.svg";
// import { ReactComponent as UserIcon } from "../img/icons/user.svg";
// import { ReactComponent as UsersIcon } from "../img/icons/users.svg";

let isCollapsed = false;

// Main Component
const Sidebar = (props) => {
  const { t } = useTranslation();
  isCollapsed = props.isCollapsed;
  const isLoggedIn = useSelector((state) => state.user.isLoggedIn);
  const dispatch = useDispatch();
  const { logout } = bindActionCreators(actionCreators, dispatch);
  const [modalV2, setModalV2] = useState(false);
  const [authModal, setAuthModal] = useState(false);
  const serverIP = "000.000.000.000";
  const streamKey = "xxxxxxxxxxxxxxxxxxxx";

  // Fonction pour obtenir le bon chemin avec /corearena-app
  const getPath = (path) => path;

  const handleLogout = (e) => {
    e.preventDefault();
    axios
      .get(process.env.REACT_APP_LOGOUT_ENDPOINT, { withCredentials: true })
      .then((res) => {
        if (res.status === 200) {
          logout();
          document.cookie =
            "username=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/;";
          window.location.reload();
        }
      })
      .catch((error) => {
        if (error?.response?.status === 401) logout();
        else if (error.response) {
          if (error?.response?.status === 500)
            toast.error("Internal server error.");
        } else if (error.request)
          toast.error("We are experiencing service outages.");
        else
          toast.error("Something is blocking you from accessing our servers.");
      });
  };
  function hideModalV2() {
    setModalV2(false);
  }
  function showModalV2() {
    setModalV2(true);
  }

  const handleSidebarStreamAccess = (e, targetPath) => {
    if (isLoggedIn) return;
    e.preventDefault();
    if (targetPath) {
      localStorage.setItem("postLoginRedirect", targetPath);
    }
    setAuthModal(true);
  };

  return (
    <SidebarStyle isCollapsed={isCollapsed}>
      <Header>Core Arena</Header>
      <span>
        <MobileView>
          {/* Go Live On Mobile */}
          <Button icon variant="primary" onClick={showModalV2}>
            <VideoIcon />
          </Button>
        </MobileView>
      </span>
      
      {/* V2 Modal for Testing */}
      <Modal isOpen={modalV2} onRequestClose={hideModalV2} hideModal={hideModalV2}>
        {isLoggedIn ? (
          <StartStreamV2
            serverIP={serverIP}
            streamKey={streamKey}
            hideModal={hideModalV2}
            eventSlug={null}
          />
        ) : (
          <AuthModal tabIndex={2} hideModal={hideModalV2} />
        )}
      </Modal>

      <Modal isOpen={authModal} onRequestClose={() => setAuthModal(false)} hideModal={() => setAuthModal(false)}>
        <AuthModal tabIndex={2} hideModal={() => setAuthModal(false)} />
      </Modal>
      
      <Container>
        <UpSection>
          <ListGroup>
            <NavLink
              to={getPath("/")}
              active={props.currentPage === "/"}
              onClick={props.handleCurrentPage}
              text={t('nav.home')}
              notification="0"
              data-tour="nav-home"
            >
              <HomeIcon />
            </NavLink>
            <NavLink
              to=""
              active={props.currentPage === "/stream-dashboard"}
              text={t('nav.goLive')}
              onClick={showModalV2}
              notification="0"
              data-tour="nav-go-live"
            >
              <VideoIcon />
            </NavLink> 
            {/* <NavLink
              to="/Components"
              active={props.currentPage === "/Components"}
              onClick={props.handleCurrentPage}
              text="Components"
              >
              <VideoIcon />
            </NavLink> */}
            {/* <NavLink to="/create-tournament" text="Create a tournament">
                <CreateIcon />
              </NavLink> */}
          </ListGroup>
          <ListGroup>
            <NavLink
              to={getPath("/events")}
              active={props.currentPage === "/events"}
              onClick={props.handleCurrentPage}
              text={t('nav.events')}
              notification="0"
              data-tour="nav-events"
            >
              <EventIcon />
            </NavLink>
            <NavLink
              to={getPath("/events/tournaments")}
              active={props.currentPage === "/events/tournaments"}
              onClick={props.handleCurrentPage}
              text="Tournament Events"
              notification="0"
            >
              <EventIcon />
            </NavLink>
            {/* <NavLink to="/live-channels" text="Live Channels">
                <PlayIcon />
              </NavLink> */}
            {isLoggedIn && (
              <NavLink
                to={getPath("/my-events")}
                active={props.currentPage === "/my-events"}
                onClick={props.handleCurrentPage}
                text={t('nav.myEvents')}
                data-tour="nav-my-events"
              >
                <EventIcon />
              </NavLink>
            )}
            {/* <NavLink to="/my-videos" text="My videos">
                <VideoIcon />
              </NavLink> */}
            {/* <NavLink to="/my-teams" text="My Team">
                <UserIcon />
              </NavLink> */}
          </ListGroup>
          {/* <ListGroup>
              <NavLink to="/followed-channels" text="Followed Channels">
                <UsersIcon />
              </NavLink>
            </ListGroup> */}
          <RecommendedChannels isLoggedIn={isLoggedIn} onStreamAccess={handleSidebarStreamAccess} />
        </UpSection>
        <DownSection>
          <ListGroup isCollapsed={isCollapsed}>
            {/* <NavLink
                to="/help-center"
                active={props.currentPage === "/help-center"}
                onClick={props.handleCurrentPage}
                text="Help Center">
                <HelpIcon />
              </NavLink> */}
            {isLoggedIn ? (
              <NavLink to="" onClick={handleLogout} text={t('auth.logout')}>
                <LogoutIcon />
              </NavLink>
            ) : (
              ""
            )}
            <footer>
              <Link to={getPath("/legal/rgpd")}>{t('legal.privacyPolicy')}</Link>
              <Link to={getPath("/legal/cgu")}>{t('legal.cgu')}</Link>
              <Link to={getPath("/legal/faq")}>{t('legal.faq')}</Link>
              <Link to={getPath("/legal/mentions-legales")}>{t('legal.mentions')}</Link>
              <Link to={getPath("/contact")}>{t('legal.contact')}</Link>
            </footer>
          </ListGroup>
        </DownSection>
      </Container>
    </SidebarStyle>
  );
};
export default Sidebar;

// SubComponents
const Header = ({ children }) => {
  return (
    <HeaderStyle isCollapsed={isCollapsed}>
      <Link to="/" data-tour="header-logo">
        <div style={{
          background: '#2563eb', // bleu
          borderRadius: '8px',
          padding: '8px',
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          width: '48px',
          height: '48px'
        }}>
          {/* Always use light logo on the blue tile for contrast */}
          <BrandLogo variant="light" />
        </div>
        <span>{children}</span>
      </Link>
    </HeaderStyle>
  );
};
const NavLink = ({ to, text, children, active, notification, ...res }) => {
  return (
    <NavLinkStyle
      data-tip={text}
      data-place="right"
      active={active}
      notification={notification}
      isCollapsed={isCollapsed}
      {...res}
    >
      {to !== "" && (
        <Link to={to}>
          {children}
          {text && <span>{text}</span>}
          {notification && notification > 0 && (
            <span>{To2Digits(notification)}</span>
          )}
        </Link>
      )}
      {to === "" && (
        <div>
          {children}
          {text && <span>{text}</span>}
          {notification && notification > 0 && (
            <span>{To2Digits(notification)}</span>
          )}
        </div>
      )}
    </NavLinkStyle>
  );
};
const Chaneel = (props) => {
  const safeViews = Number(props.views);
  const viewsCount = Number.isFinite(safeViews) ? safeViews : 0;

  return (
    <ChaneelStyle isCollapsed={isCollapsed}>
<Link to={props.to ? props.to : ""} {...props}>
        <SmallAvatar src={props.src} alt={props.alt} />
        <div>
          <span>{props.name}</span>
          <span>{props.game}</span>
        </div>
        <span>{handleBigNumbers(viewsCount)}</span>
      </Link>
    </ChaneelStyle>
  );
};
const RecommendedChannels = ({ isLoggedIn, onStreamAccess }) => {
  const { t } = useTranslation();
  const location = useLocation();
  const [channels, setChannels] = useState([]);

  const normalizeChannels = useCallback((payload) => {
    const liveStreams = Array.isArray(payload)
      ? payload
      : Array.isArray(payload?.data)
        ? payload.data
        : Array.isArray(payload?.lives)
          ? payload.lives
          : [];

    return liveStreams.map((item) => {
      const parsedViewerCount = Number(
        item?.viewerCount ?? item?.views ?? item?.viewsCount ?? 0
      );

      return {
        username: item?.username || "Streamer",
        avatar: item?.avatar || "",
        game: item?.stream_games?.name || item?.game?.name || item?.game || "",
        viewerCount: Number.isFinite(parsedViewerCount) ? parsedViewerCount : 0,
      };
    });
  }, []);

  const getRecommendedChannels = useCallback(() => {
    axios
      .get(ENV_CONFIG.STREAMS_ENDPOINT + "?recommended=", {
        withCredentials: true,
      })
      .then((res) => {
        setChannels(normalizeChannels(res.data));
      })
      .catch(() => { });
  }, [normalizeChannels]);

  useEffect(() => {
    getRecommendedChannels();

    const id = setInterval(() => {
      if (!document.hidden) getRecommendedChannels();
    }, 5000);

    const handleViewerRefresh = () => {
      getRecommendedChannels();
    };
    const handleFocus = () => {
      getRecommendedChannels();
    };
    const handleVisibilityChange = () => {
      if (!document.hidden) getRecommendedChannels();
    };

    window.addEventListener("corearena:viewers:refresh", handleViewerRefresh);
    window.addEventListener("focus", handleFocus);
    document.addEventListener("visibilitychange", handleVisibilityChange);

    return () => {
      clearInterval(id);
      window.removeEventListener("corearena:viewers:refresh", handleViewerRefresh);
      window.removeEventListener("focus", handleFocus);
      document.removeEventListener("visibilitychange", handleVisibilityChange);
    };
  }, [getRecommendedChannels, location.pathname]);

  return (
    <RecommendedChannelsStyle isCollapsed={isCollapsed}>
      <span>{isLoggedIn ? `${t('nav.followingChannels')}` : `${t('nav.recommended_channels')}`}</span>
      {!channels.length || !channels || !isArray(channels) ? (
        <></>
      ) : (
        <div>
          {channels.map((item, index) => {
            const streamPath = "/stream/" + item.username;
            return (
              <Chaneel
                name={item?.username}
                game={item?.game}
                views={item?.viewerCount}
                to={streamPath}
                onClick={(e) => onStreamAccess?.(e, streamPath)}
                src={item?.avatar}
                alt={item?.username}
                data-tip={item?.username}
                data-place="right"
                key={index}
              />
            );
          })}
        </div>
      )}
    </RecommendedChannelsStyle>
  );
};





// This function will return a given css style if Sidebar Collapsed or on Tablet view
const collapse = (style) => css`
  ${({ isCollapsed }) => isCollapsed && style};
  @media only screen and (max-width: 1200px) {
    ${style}
  }
`;

// Styling
const SidebarCollapsed = css`
  width: 65px;
  min-width: 65px;
  ul {
    padding-left: 0;
    padding-right: 0;
    margin-right: 7px;
    margin-left: 7px;
  }
`;
const SidebarStyle = styled.aside`
  background-color: ${({ theme }) => theme.color.background};
  border-right: 1px solid ${({ theme }) => theme.color.border};
  width: 255px;
  min-width: 255px;
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  ${collapse(SidebarCollapsed)}

  >span:nth-of-type(1) {
    position: fixed;
    bottom: 17px;
    right: 17px;
    button {
      padding: 17px;
      transition: transform 200ms;
      z-index: 2;
      svg {
        max-width: 20px;
        max-height: 20px;
        width: 30px;
        height: 30px;
        path {
          fill: white;
        }
      }
      :active,
      :focus {
        transition: transform 200ms;
        transform: scale(1.2);
      }
    }
  }
  @media (max-width: 576px) {
    position: fixed;
    top: 0;
    bottom: 0;
    left: -100px;
    z-index: 7;
  }
`;

const ListGroupCollapsed = css`
  padding-left: 0;
  padding-right: 0;
  margin-right: 7px;
  margin-left: 7px;
  footer {
    display: none;
  }
`;
const ListGroup = styled.ul`
  ${({ theme }) => theme.gap("4px", "column")};
  padding: 10px;
  button {
    padding: 0;
    min-width: 100%;
    min-height: 48px;
    max-height: 48px;
    svg {
      margin-right: 0 !important;
    }
  }
  footer {
    display: flex;
    flex-wrap: wrap;
    text-align: center;
    a {
      font-size: 11px;
      color: ${({ theme }) => theme.color.secondaryIcon};
      line-height: 1.3;
      :hover {
        text-decoration: underline;
      }
      :not(:last-child) {
        margin-right: 5px;
      }
    }
  }
  &:not(:last-child) {
    border-bottom: 1px solid ${({ theme }) => theme.color.border};
  }
  ${collapse(ListGroupCollapsed)}
`;

const RecommendedChannelsCollapsed = css`
  & > span {
    display: none;
  }

  button {
    span {
      display: none;
    }
    svg {
      display: block;
    }
  }
`;
const RecommendedChannelsStyle = styled(ListGroup)`
  & > span {
    text-transform: uppercase;
    font-size: 12px;
    font-family: "Poppins Medium";
    padding: 12px;
    display: block;
    color: ${({ theme }) => theme.color.linkText};
    letter-spacing: 0.045em;
  }
  button {
    min-width: auto;
    box-sizing: content-box;

    span {
      font-family: "Poppins Regular";
      color: ${({ theme }) => theme.color.linkText};
    }
    svg {
      display: none;
      margin: 0 !important;
      path {
        fill: ${({ theme }) => theme.color.linkText};
      }
    }
  }
  ${collapse(RecommendedChannelsCollapsed)}
`;

const ChaneelCollapsed = css`
  a {
    padding: 8px;
    border-radius: 50px;
    justify-content: center;
    align-items: center;
    & > div:nth-child(1) {
      margin: 0;
      display: flex;
    }
    & > div:nth-child(2),
    & > span {
      display: none;
    }
  }
`;
const ChaneelStyle = styled.li`
  a {
    display: flex;
    align-items: center;
    padding: 10px;
    border-radius: 8px;
    :hover {
      background-color: ${({ theme }) => theme.color.secondaryBg};
    }
    & > div:nth-child(1) {
      margin-right: 10px;
    }
    & > div:nth-child(2) {
      flex: 1;
      overflow: hidden;
      margin-right: 12px;
      span {
        ${({ theme }) => theme.linesLimits(1, 1.3)};
        &:first-child {
          color: ${({ theme }) => theme.color.linkText};
          font-size: 14px;
          font-family: "Poppins Semibold";
          font-weight: 600;
          letter-spacing: 0.045em;
        }
        &:last-child {
          color: ${({ theme }) => theme.color.secondaryIcon};
          font-size: 12px;
          opacity: 0.8;
          font-family: "Poppins Light";
          font-weight: 300;
        }
      }
    }
    & > span {
      margin-left: auto;
      color: ${({ theme }) => theme.color.linkText};
      font-size: 12px;
      position: relative;
      font-family: "Poppins Regular";
      letter-spacing: 0.045em;
      &::before {
        content: "";
        width: 6px;
        height: 6px;
        background-color: ${({ theme }) => theme.color.danger};
        position: absolute;
        left: -10px;
        top: 50%;
        border-radius: 50px;
        transform: translateY(-50%);
      }
    }
  }
  ${collapse(ChaneelCollapsed)}
`;

const HeaderCollapsed = css`
  a {
    span {
      display: none;
    }
    svg {
      margin: 0 auto;
      width: 35px;
      height: 35px;
      min-width: 27px;
    }
  }
`;
const HeaderStyle = styled.header`
  background-color: ${({ theme }) => theme.color.background};
  width: 100%;
  overflow: hidden;
  a {
    display: flex;
    align-items: center;
    justify-content: flex-start;
    transition: color 0s;
    font-size: 18px;
    padding: 12px 10px;
    span {
      margin-left: 5%;
      white-space: nowrap;
      color: ${({ theme }) => theme.color.primaryText};
    }
    svg {
      min-width: 26px;
    }
  }
  ${collapse(HeaderCollapsed)}
`;

const Container = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: stretch;
  flex-direction: column;
  overflow-y: auto;
  overflow-x: hidden;
  width: 100%;
  padding-bottom: 12px;
  flex: 1;
  ${({ theme }) => theme.hideScroller}
`;
const UpSection = styled.div`
  flex: 1;
  overflow: auto;
  ${({ theme }) => theme.hideScroller()}
`;
const DownSection = styled.div`
  margin-top: auto;
  ul {
    border-top: 1px solid ${({ theme }) => theme.color.border};
  }
`;

const NavLinkCollapsed = css`
  a,
  div {
    min-height: 48px;
    max-height: 48px;
    padding: 0;
    span:nth-child(3),
    span:nth-child(2) {
      display: none;
    }
    svg {
      margin: 0 auto;
      width: 18px;
    }
    ${({ notification, theme }) =>
    notification &&
    notification > 0 &&
    `
    position: relative;
    ::after {
      content: "";
      width: 6px;
      height: 6px;
      background-color: ${theme.color.danger};
      position: absolute;
      border-radius: 50px;
      top: 16px;
      right: 16px;
    }
    `}
  }
`;
const NavLinkStyle = styled.li`
  a,
  div {
    cursor: pointer;
    display: flex;
    align-items: center;
    padding: 12px;
    border-radius: 8px;
    user-select: none;
    color: ${({ theme, active }) =>
    active ? theme.color.primaryText : theme.color.linkText};
    background-color: ${({ theme, active }) =>
    active ? theme.color.secondaryBg : "transparent"};
    transition: background-color 00ms;

    svg {
      width: 14px;
      min-width: 14px;
      max-width: 14px;
      path {
        fill: ${({ theme, active }) =>
    active ? theme.color.primaryText : theme.color.secondaryIcon};
      }
    }
    &.active,
    &:hover,
    &:focus {
      background-color: ${({ theme }) => theme.color.secondaryBg};
    }
    &:active {
      svg {
        transform: scale(0.95);
      }
    }
    span:nth-child(2) {
      white-space: nowrap;
      font-size: 14px;
      text-transform: capitalize;
      margin-left: 10px;
      margin-right: 5px;
      flex: 1;
      ${({ theme }) => theme.linesLimits(1, 1.3)};
    }
    span:nth-child(3) {
      background-color: ${({ theme }) => theme.color.danger};
      font-family: "Poppins Medium";
      padding: 3px 4px;
      text-align: center;
      border-radius: 50px;
      margin-left: auto;
      font-size: 12px;
      margin-left: 2px;
      color: white;
      min-width: 20px;
    }
  }
  ${collapse(NavLinkCollapsed)}
`;
